export default {"src":"/_next/static/media/0x0000000000095413afc295d19edeb1ad7b71c952.ca4f8947.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};